import { render, staticRenderFns } from "./RevokeIcon.vue?vue&type=template&id=ee36bba4&"
import script from "./RevokeIcon.vue?vue&type=script&lang=ts&"
export * from "./RevokeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports